export const GET_ACTIVE_CITIES_PENDING = 'get-active-cities-request';
export const GET_ACTIVE_CITIES_SUCCESS = 'get-active-cities-success';
export const GET_ACTIVE_CITIES_FAILURE = 'get-active-cities-failure';